import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [{
		path: "/",
		name: "Code",
		component: () => import("@/views/code.vue")
	}, {
		path: "/auth_token",
		name: "AuthToken",
		component: () => import("@/views/auth_token.vue"),
	}, {
		path: "/recived_result",
		name: "recivedResult",
		component: () => import("@/views/result.vue"),
	}, {
		path: "/unified_pay",
		name: "UnifiedPay",
		component: () => import("@/views/unified_pay.vue"),
	}, {
		path: "/wechat_pay",
		name: "WechatPay",
		component: () => import("@/views/wechat_pay.vue"),
	}, {
		path: "/wechat_callback",
		name: "WechatCallback",
		component: () => import("@/views/wechat_callback.vue"),
	}]
})